import * as React from "react"
import styled from "styled-components"

import Icon from "~/components/atoms/Icon"
import { Color, LineHeight, SpacingSize, TextSize } from "~/consts/style-mixins"

interface Props {
  children: string
  className?: string
}

const ErrorText = ({ children, className }: Props) => {
  return (
    <Container className={className}>
      <Icon type="Error" size={20} color={Color.Attention} />
      <Text>{children}</Text>
    </Container>
  )
}

export default ErrorText

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Text = styled.p`
  font-size: ${TextSize.M}px;
  line-height: ${LineHeight.S}%;
  margin-left: ${SpacingSize.XS}px;
`
